module.exports = __webpack_public_path__ + "0723b152466f3413539f25b742795c98.pdf";